import getFinanceTermsByTier from './utils/getFinanceTermsByTier.js';
import getDealerSupportedDealTypes from './utils/getDealerSupportedDealTypes.js';
import getTransformedSelectedCriteria from './utils/getTransformedSelectedCriteria.js';

/**
 * Applies the Dealer.com settings we retrieved for this dealer to the calculator configuration. This
 * includes deal type, negotiation, taxes and fees, selected criteria, and custom disclaimer.
 *
 * @param {Object} config - The existing calculator configuration object.
 * @param {Object} drSettings - The fetched dealer settings object.
 * @param {('New'|'Used')} vehicleType - The type of vehicle.
 * @returns {Object} The updated calculator configuration object with applied DR settings.
 */

async function applyDrSettings(config, drSettings, vehicleType) {
  const supportedDeals = getDealerSupportedDealTypes(drSettings, vehicleType);
  const dealType = drSettings?.defaultDealType || 'finance';
  return {
    ...config,
    supportedDealTypes: config.supportedDealTypes ?? supportedDeals,
    initialDealType: config.initialDealType ?? (supportedDeals.includes(dealType) ? dealType : 'finance'),
    enableNegotiation: config.enableNegotiation ?? drSettings[`canNegotiate${vehicleType}`],
    enableTaxesAndFees: config.enableTaxesAndFees ?? drSettings.applyTaxesAndFees,
    includeTaxesAndFees: config.includeTaxesAndFees ?? undefined,
    isDueAtSigningAmountDeduct: drSettings.leasing.isDueAtSigninAmountDeduct ?? false,
    selectedCriteria: getTransformedSelectedCriteria(config?.selectedCriteria, drSettings, vehicleType),
    oemLabels: config.ecommerce === 'Accelerate' ? drSettings.oemLabels : {},
    shortCustomDisclaimer: config.shortCustomDisclaimer ?? drSettings?.shortCustomDisclaimer,
    defaultFinanceTerms: config.defaultFinanceTerms ?? (vehicleType === 'New' ? drSettings?.financing?.defaultTermNew : drSettings?.financing?.defaultTermUsed),
    availableFinanceTermsByTier: config.availableFinanceTermsByTier ?? getFinanceTermsByTier(drSettings)
  };
}
export { applyDrSettings as default };
